import React, { useState } from "react";
import { X } from "lucide-react";
import { inp, lbl } from "./shared";
import { FieldList, StatusSelect, BASIC_FIELDS, PROFILE_FIELDS, TEXT_FIELDS } from "./product-form/Fields";
import { AccordsEditor, newKey } from "./product-form/AccordsEditor";
import { MediaUploader } from "./product-form/MediaUploader";
import { ClassificationFields } from "./product-form/ClassificationFields";
import { WearFields } from "./product-form/WearFields";
import { AICopyButton } from "./product-form/AICopyButton";

const withKeys = (initial) => ({ ...initial, accords: (initial.accords || []).map((a) => ({ ...a, _k: newKey() })) });
const stripKeys = (p) => ({ ...p, accords: (p.accords || []).map(({ _k, ...a }) => a) });

const VideoTitles = ({ p, set }) => (
  <div className="md:col-span-2 grid md:grid-cols-2 gap-4">
    <div><label className={lbl}>Video Section Title (EN)</label><input value={p.videos_title_en || ""} onChange={(e) => set("videos_title_en", e.target.value)} data-testid="pf-videos-title-en" className={inp} placeholder="e.g. The Making of Latte Oud" /></div>
    <div><label className={lbl}>عنوان قسم الفيديو (AR)</label><input dir="rtl" value={p.videos_title_ar || ""} onChange={(e) => set("videos_title_ar", e.target.value)} data-testid="pf-videos-title-ar" className={inp} placeholder="مثال: مراحل تصميم عطر لاتيه عود" /></div>
  </div>
);

export function ProductForm({ initial, onSave, onCancel }) {
  const [p, setP] = useState(() => withKeys(initial));
  const set = (k, v) => setP((prev) => ({ ...prev, [k]: v }));

  return (
    <div className="fixed inset-0 z-[90] flex items-start justify-center p-4 overflow-y-auto">
      <div className="absolute inset-0 bg-black/80" onClick={onCancel} />
      <div className="relative bg-[#0F0F0F] border border-[#262421] w-full max-w-3xl my-8 p-8">
        <div className="flex justify-between items-center mb-6">
          <h2 className="serif text-2xl">{initial.id ? "Edit" : "Add"} Product</h2>
          <button onClick={onCancel}><X size={22} className="text-[#8A857D]" /></button>
        </div>
        <div className="grid md:grid-cols-2 gap-4">
          <FieldList fields={BASIC_FIELDS} p={p} set={set} />
          <StatusSelect value={p.status} onChange={(v) => set("status", v)} />
          <FieldList fields={PROFILE_FIELDS} p={p} set={set} />
          <AccordsEditor p={p} set={set} />
          <ClassificationFields p={p} set={set} />
          <WearFields p={p} set={set} />
          <AICopyButton p={p} setP={setP} />
          <FieldList fields={TEXT_FIELDS} p={p} set={set} />
          <div className="md:col-span-2">
            <label className={lbl}>Images</label>
            <MediaUploader items={p.images} onChange={(v) => set("images", v)} accept="image/*" box="w-20 h-24" testId="pf-upload" okText="Image uploaded" failText="Upload failed" />
            <input value={p.images.join(", ")} onChange={(e) => set("images", e.target.value.split(",").map((s) => s.trim()).filter(Boolean))} placeholder="or paste image URLs comma separated" className={inp + " mt-3"} />
          </div>
          <VideoTitles p={p} set={set} />
          <div className="md:col-span-2">
            <label className={lbl}>رحلة العطر · Journey media (images & videos — any length)</label>
            <MediaUploader items={p.videos || []} onChange={(v) => set("videos", v)} accept="image/*,video/*" box="w-28 h-24" testId="pf-upload-video" label=" Image / Video" okText="Media uploaded" failText="Upload failed (file may be too large)" />
          </div>
          <label className="md:col-span-2 flex items-center gap-3 text-sm">
            <input type="checkbox" checked={p.featured} onChange={(e) => set("featured", e.target.checked)} className="accent-[#C49A6C]" />
            Featured on homepage
          </label>
        </div>
        <div className="flex gap-3 mt-8">
          <button onClick={() => onSave(stripKeys(p))} data-testid="pf-save" className="bg-[#C49A6C] text-[#0B0A08] text-xs uppercase tracking-[0.2em] px-8 py-3 hover:bg-[#E7CBA9]">Save</button>
          <button onClick={onCancel} data-testid="pf-cancel" className="border border-[#262421] text-xs uppercase tracking-[0.2em] px-8 py-3 hover:border-[#C49A6C]">Cancel</button>
        </div>
      </div>
    </div>
  );
}
